module.exports = __webpack_public_path__ + "img/ver3.9958e80c.jpg";